import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[render]'
})
export class RenderDirective {

  @Input() set render(allowedTypes: string[]) {
    if(this.checkType(allowedTypes)) this.viewContainer.createEmbeddedView(this.templateRef);
    else this.viewContainer.clear();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private readonly route: ActivatedRoute,
  ) {}

  private checkType(allowedTypes: string[]): boolean {
    const activeLob = this.route.snapshot.paramMap.get('name')!
    return allowedTypes.some(item => item === activeLob)
  }
}
